import { render, staticRenderFns } from "./MapLocations.vue?vue&type=template&id=b4a7d726&"
import script from "./MapLocations.vue?vue&type=script&lang=js&"
export * from "./MapLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4a7d726')) {
      api.createRecord('b4a7d726', component.options)
    } else {
      api.reload('b4a7d726', component.options)
    }
    module.hot.accept("./MapLocations.vue?vue&type=template&id=b4a7d726&", function () {
      api.rerender('b4a7d726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/MapLocations.vue"
export default component.exports